import { useCallback } from "react";
import { useField } from "formik";

export const useAffinityField: typeof useField = (...args) => {
  const [
    { onChange: originalOnChange, ...inputProps },
    metaProps,
    { setValue: originalSetValue, ...formikHelpers },
    ...rest
  ] = useField(...args);
  const onChange = useCallback(
    (e) => {
      formikHelpers.setError(undefined);
      originalOnChange(e);
    },
    [formikHelpers, originalOnChange]
  );
  const setValue = useCallback<typeof originalSetValue>(
    (value, shouldValidate) => {
      formikHelpers.setError(undefined);
      return originalSetValue(value, shouldValidate);
    },
    [formikHelpers, originalSetValue]
  );
  return [{ onChange, ...inputProps }, metaProps, { ...formikHelpers, setValue }, ...rest];
};
